import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { SidebarNavTheme } from '@fcom/ui-components/components/sidebar-nav/enums';

import { NavigationMenuService } from '../../../services/navigation-menu/navigation-menu.service';
import { MenuItem } from '../../../interfaces/menu.interface';
import { ElementTypes, GaContext } from '../../../interfaces/gtm.interface';

@Component({
  selector: 'fin-section-navi',
  styleUrls: ['./section-navi.component.scss'],
  templateUrl: './section-navi.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SectionNaviComponent {
  private navigationMenuService = inject(NavigationMenuService);

  readonly ElementTypes = ElementTypes;
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly TRACKING_CONTEXT = GaContext.SECTION_NAVIGATION;

  readonly activeNaviItem = toSignal<MenuItem>(this.navigationMenuService.activeNaviItem);
  readonly activeNaviSection = toSignal<MenuItem>(this.navigationMenuService.activeNaviSection);

  title = input<string | undefined>(undefined);
  showTitle = input<boolean>(true);
  topSpacing = input<boolean>(true);
  bottomSpacing = input<boolean>(true);
  theme = input<SidebarNavTheme>(SidebarNavTheme.EMBLEM_LEFT);
  /**
   * FAQ like pages had nested version, with the possibility to render text from 'linkText', this input is for that use-case
   */
  nested = input<boolean>(false);
}
